import * as t from 'io-ts';
export var EmailDigestDeliveryDays = t.keyof({
  "default": null,
  weekdays: null,
  daily: null
});
var DigestDeliveryOption = t.type({
  label: t.string,
  value: EmailDigestDeliveryDays
});
export var CommunityConfiguration = t.type({
  digestDeliveryOptions: t.array(DigestDeliveryOption)
});
export var NotificationPreferences = t.type({
  challengeDigest: t["boolean"],
  challengeReminder: t["boolean"],
  emailDigestDeliveryDays: EmailDigestDeliveryDays,
  challengeRequests: t["boolean"],
  newMessages: t["boolean"],
  prospectAccepted: t["boolean"],
  challengeFeedback: t["boolean"],
  discussionReplies: t["boolean"],
  discussionComments: t["boolean"],
  discussionMentions: t["boolean"],
  challengeResponseComments: t["boolean"],
  badgeEarned: t["boolean"],
  rewardFulfilled: t["boolean"],
  perksAvailable: t["boolean"],
  adminSummary: t["boolean"],
  challengesPush: t["boolean"],
  referralsPush: t["boolean"],
  rewardsPush: t["boolean"],
  badgesPush: t["boolean"],
  discussionsPush: t["boolean"],
  unsubscribedFromAllEmails: t["boolean"],
  unsubscribedFromAllPushes: t["boolean"]
});
var Error = t.type({
  message: t.string
});
export var EditNotificationPreferencesOutput = t.type({
  editNotificationPreferences: t.union([t.type({
    __typename: t.literal('EditNotificationPreferencesErrors'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('EditNotificationPreferencesResult'),
    notificationPreferences: NotificationPreferences
  })])
});